import AbstractElement from '../AbstractElement';

export default class CLegendElement extends AbstractElement{
    constructor(axisX,axisY,width,config){
        super();
        this._axisX = axisX;
        this._axisY = axisY;
        this._width=width;
        this._scaleX=((this._width-50)/this._all*this._contains)/100;
        this._config=config;
    }

    update(context){
        let me=this;
        let axisX=this._axisX;
        let axisY=this._axisY;
        let size=0;
        context.beginPath();
        context.stroke();
        size=30;
        axisX=this.getCenterPosition(context);
        this._config['labels'].forEach(function (item,index) {
            size=me.drawItem(context, item['name'], item['color'], axisX, axisY);
            axisX+=size;
        });
        context.stroke();
    }

    getCenterPosition(context){
        let size=0;
        this._config['labels'].forEach(function (item,index) {
            let measureText=context.measureText(item['name']);
            let widthText=measureText.width;
            size+=widthText+5+20+20+10;
        });
        return this._width-(this._width+size)/2;
    }

    drawItem(context, text, color, axisX, axisY){
        let measureText=context.measureText(text);
        let widthText=measureText.width;
        let heightText=5;
        let shiftX=widthText+5;
        context.fillStyle='#000000';
        context.fillText(text,axisX,axisY+15);

        let height=20;
        context.fillStyle = color;
        context.fillRect(axisX+shiftX,axisY,20,height);
        return shiftX+20+10;
    }
}


// WEBPACK FOOTER //
// ./src/components/cchart/Template/CLegendElement.js